function NotFound() {
  return (
    <div className="flex h-full w-full items-center justify-center flex-col p-8 mb-16">
      <p>NotFound</p>
    </div>
  );
}

export default NotFound;
